import { render } from "./PlayerCore.vue?vue&type=template&id=5980e659"
import script from "./PlayerCore.vue?vue&type=script&lang=js"
export * from "./PlayerCore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__